var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',[_c('overview-description',[_c('h2',[_vm._v("Competency Overview")]),_vm._v(" "),_c('p',[_vm._v("The competency overview will show how your are progressing towards your goals")])]),_vm._v(" "),_c('variable-data-visualiser',{staticClass:"componentSeparator",attrs:{"dataCategories":_vm.topics,"compareList":_vm.generateCompetencies}}),_vm._v(" "),_c('collected-badges',{attrs:{"topic":"competencies"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ce49bbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Competencies.vue
// module id = 862
// module chunks = 0